export default {
  amount: null,
  connection_token: null,
  event: null,
  note: "",
  snapshot_token: null,
};
